import { render, staticRenderFns } from "./Opportunities.vue?vue&type=template&id=558855c8&"
import script from "./Opportunities.vue?vue&type=script&setup=true&lang=ts&"
export * from "./Opportunities.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports